import type { JSX } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { FormSectionProps } from './types';

export function AdditionalInfoSection({ register, errors }: FormSectionProps): JSX.Element {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Additional Information</h3>
      <div className="space-y-2">
        <Label htmlFor="benefits">Benefits</Label>
        <textarea
          id="benefits"
          {...register('benefits')}
          className="flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-xs focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="applicationUrl">Application URL</Label>
        <Input id="applicationUrl" type="url" {...register('applicationUrl')} />
        {errors.applicationUrl && (
          <p className="text-sm text-red-500">{errors.applicationUrl.message}</p>
        )}
      </div>
    </div>
  );
}
